import { ref, watch } from 'vue';
import { useStore } from 'vuex';

// Runs a single-row KPI query and keeps it in step with the cross-filter.
// `map` turns the raw row into the numbers the cards display. Pass `sql` as a
// function when it depends on reactive state (e.g. which fields are configured).
export function useKpiQuery(sql, map) {
  const store = useStore();
  const totals = ref(map({}));

  const refresh = async () => {
    const conn = store.getters.getDBConnection;
    if (!conn) return;
    try {
      const result = await conn.query(typeof sql === 'function' ? sql() : sql);
      const row = result.toArray()[0]?.toJSON();
      totals.value = map(row || {});
    } catch (error) {
      console.error('Error refreshing KPIs:', error);
    }
  };

  watch(
    () => [store.getters.getDataLoaded, store.state.filterContext?.filtersLastUpdated?.value],
    ([loaded]) => {
      if (loaded && store.getters.isDuckDBInitialized) refresh();
    },
    { immediate: true }
  );

  return { totals, refresh };
}

// Arrow returns BigInt for COUNT and Decimal for some aggregates.
export const num = (value) => {
  if (value === null || value === undefined) return 0;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};
